<template>
  <div>
    <!-- Page title -->
    <b-row class="justify-content-center">
      <img src="/images/reflections_logo.png" class="mb-5 mt-3" />
    </b-row>

    <!-- Help row with faqs and contact form -->
    <b-row class="pb-2 pl-2 pr-2 justify-content-center pt-0">
      <!-- FAQs -->
      <FAQSection />

      <!-- Form -->
      <ContactForm />
    </b-row>
  </div>
</template>

<script>
// import FAQCard from "../components/contactus-components/FAQCard.vue";
import FAQSection from "../components/contactus-components/FAQSection.vue";
import ContactForm from "../components/contactus-components/ContactForm.vue";

export default {
  name: "ContactUs",
  components: {
    // FAQCard,
    FAQSection,
    ContactForm,
  },
};
</script>


<style>
.contact-title {
  font-size: 1.3rem;
  line-height: 1.2;
  font-weight: 600;
}

.contact-section {
  border: 1px solid #eeeeee;
  background: #fff;
  border-radius: 5px;
  /* margin-top: 15px; */
  margin-bottom: 15px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.04);
}
</style>

<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
}

.center-title2 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
  font-size: 2rem;
}
</style>